/* eslint-disable react/prop-types */
import { createContext, useCallback, useMemo } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, getToken } from 'firebase/messaging';

const FirebaseContext = createContext({});
export { FirebaseContext };

export const firebase = { app: null, messaging: null };

export default ({ children }) => {
  const webGetToken = useCallback(async (firebaseConfig, vapid) => {
    const app = initializeApp(firebaseConfig);
    firebase.app = app;

    try {
      const messaging = getMessaging(app);
      firebase.messaging = messaging;
      const token = await getToken(messaging, { vapidKey: vapid });
      return token;
    } catch (e) {
      console.error('error', e);
    }
  }, []);

  const showMessage = useCallback(messageHandle => {
    try {
      onMessage(firebase.messaging, payload => {
        messageHandle(payload);
      });
    } catch (e) {
      console.error(e);
    }
  }, []);

  const value = useMemo(() => ({ webGetToken, showMessage }), [webGetToken, showMessage]);

  return <FirebaseContext.Provider value={value}>{children}</FirebaseContext.Provider>;
};
